import jwtAuthAxios from "../auth/jwtAuth";

const storeServices = {};

storeServices.createStore = async (body = {}, params = "") => {
    const {data} = await jwtAuthAxios.post(`/automations/stores${params}`, body);
    return data;
};

storeServices.updateStore = async (id, body = {}, params = "") => {
    const {data} = await jwtAuthAxios.put(`/automations/stores/${id}${params}`, body);
    return data;
};

storeServices.deleteStore = async (id, params = "") => {
    const {data} = await jwtAuthAxios.delete(`/automations/stores/${id}${params}`);
    return data;
};

storeServices.getStores = async (params) => {
    const {data} = await jwtAuthAxios.get(`/automations/stores${ params ?? ""}`);
    return data;
};

storeServices.getStore = async (id, params="") => {
    const {data} = await jwtAuthAxios.get(`/automations/stores/${id}${params}`);
    return data;
};

export default storeServices;
